import { createContext, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "./useLocalStorage";
import { jwtDecode } from "jwt-decode";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [token, setToken] = useLocalStorage("authToken", null);
  const navigate = useNavigate();

  async function login (token) {
    setToken(token);
    navigate("/dashboard");
  };

  async function logout() {
    setToken(null);
    navigate("/dashboard/login", { replace: true });
  };

  function user() {
    if (token) {
      const value = jwtDecode(token);
      return {
        id: value.sub,
        name: value.name,
        roles: value.role,
      };
    } else {
      return null;
    }
  }

  const value = {
    token,
    user,
    login,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export function useAuth() {
  return useContext(AuthContext);
};
